"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vueTypes = _interopRequireDefault(require("ant-design-vue/es/_util/vue-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'itemListStyle1',
  props: {
    itemStyle: _vueTypes.default.object.def({}),
    defaultData: _vueTypes.default.array.def([]),
    parentIndex: _vueTypes.default.integer.def(-1)
  },
  data: function data() {
    return {};
  }
};